// setPaddingTop.js
export default function (Callback) {
  try {
    return Callback(null, parseInt(Math.sin(1.5 / 180 * Math.PI) * window.innerWidth) + 82)
  } catch (err) {
    return Callback(err)
  }
}



// WEBPACK FOOTER //
// ./src/common/lib/setPaddingTop.js